import { getAbsoluteUrl } from '../utils'
import { useSiteQuery } from '../../global/blocs/useSite'

const useAbsoluteUrl = (src) => {
  const { data: site } = useSiteQuery()
  const siteUrl = site?.site_url ?? ''
  return getAbsoluteUrl(src, siteUrl)
}

export default useAbsoluteUrl
